import { render, staticRenderFns } from "./ListSimpleManager.vue?vue&type=template&id=6c21c84f&"
import script from "./ListSimpleManager.vue?vue&type=script&lang=js&"
export * from "./ListSimpleManager.vue?vue&type=script&lang=js&"
import style0 from "./ListSimpleManager.vue?vue&type=style&index=0&id=6c21c84f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports